export default "__VITE_ASSET__a60449c4__"